import React, { useState, useEffect } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { UrduInput } from "../../../Components/Shared/UrduInput";

function AddBlogCategoryModal({
  modalOpen,
  toggleModal,
  category,
  handleSaveCategory,
}) {
  const [categoryData, setCategoryData] = useState({
    name: "",
    categoryName_ur: "",
    status: true,
  });

  const [nameError, setNameError] = useState("");

  useEffect(() => {
    if (category) {
      setCategoryData({
        name: category.name,
        categoryName_ur: category.categoryName_ur || "",
        status: category.status,
      });
    } else {
      setCategoryData({
        name: "",
        categoryName_ur: "",
        status: true,
      });
    }
  }, [category]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCategoryData((prevData) => ({
      ...prevData,
      [name]: value === "true" ? true : value === "false" ? false : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setNameError("");

    if (!categoryData.name) {
      setNameError("Category name is required.");
      return;
    }

    handleSaveCategory(categoryData, category ? category.id : null);

    setCategoryData({
      name: "",
      categoryName_ur: "",
      status: true,
    });

    toggleModal();
  };

  const handleCloseModal = () => {
    setCategoryData({
      name: "",
      categoryName_ur: "",
      status: true,
    });
    setNameError("");
    toggleModal();
  };

  return (
    modalOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white p-8 rounded-lg w-full max-w-md relative">
          <XMarkIcon
            className="absolute top-4 right-4 h-6 w-6 text-gray-600 cursor-pointer hover:text-gray-800"
            onClick={handleCloseModal}
          />
          <h3 className="text-xl font-semibold mb-6 text-gray-800">
            {category ? "Edit Blog Category" : "Add Blog Category"}
          </h3>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Category Name
              </label>
              <input
                type="text"
                name="name"
                value={categoryData.name}
                onChange={handleInputChange}
                placeholder="Blog Category Name"
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
              {nameError && (
                <p className="text-red-500 text-sm mt-1">{nameError}</p>
              )}
              <UrduInput
                label="زمرہ کا نام"
                name="categoryName_ur"
                value={categoryData.categoryName_ur}
                onChange={handleInputChange}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Status
              </label>
              <select
                name="status"
                value={categoryData.status}
                onChange={handleInputChange}
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
              >
                <option value={true}>Active</option>
                <option value={false}>Inactive</option>
              </select>
            </div>

            <div className="flex justify-end gap-3 pt-2">
              <button
                type="button"
                onClick={handleCloseModal}
                className="btn btn-reset-filter justify-center"
              >
                Cancel
              </button>
              <button
                type="submit"
                className={`btn justify-center ${
                  category ? "btn-edit text-white" : "btn-primary"
                }`}
              >
                {category ? "Update" : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  );
}

export default AddBlogCategoryModal;
